import { Box } from "@mui/material";
import React from "react";
import PageLayout from "../../components/layout/PageLayout";
import FleetMap from "./components/map/FleetMap";

const DashboardPage: React.FC = () => {
  return (
    <PageLayout variant="edgeToEdge">
      {/* The dashboard map is intentionally edge-to-edge inside the app shell. */}
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flex: 1,
            position: "relative",
          }}
        >
          <FleetMap />
        </Box>
      </Box>
    </PageLayout>
  );
};

export default DashboardPage;
